module.exports = __webpack_public_path__ + "img/39.852b59d3.png";